import { render, staticRenderFns } from "./MediaPreviewModal.vue?vue&type=template&id=56e703b8&scoped=true"
import script from "./MediaPreviewModal.vue?vue&type=script&lang=js"
export * from "./MediaPreviewModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e703b8",
  null
  
)

export default component.exports